<template>
  <div v-loading="isLoading">
    <div>
      <div class="cs-title cs-bold">
        <span>校园信息</span>
        <el-button v-if="!isReadonly" type="primary" size="mini" @click="onEditClick">编辑</el-button>
      </div>
    </div>
    <div>
      <table style="width: 100%;">
        <tr>
          <td class="cs-label">
            <span>入学日期</span>
          </td>
          <td>
            <span>{{getDateText(dataModel.EnrollmentDate)}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>目前学分</span>
          </td>
          <td>
            <span>{{`${dataModel.CurrentCredits}/${dataModel.GraduationCredits}个学分`}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>目前成绩</span>
          </td>
          <td>
            <span class="cs-color-green">{{`CGPA ${dataModel.CurrentPerformance}`}}</span>
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>大学进度</span>
          </td>
          <td>
            <el-progress :percentage="studiesProgress" style="width: 70%;" />
          </td>
        </tr>
        <tr>
          <td class="cs-label">
            <span>预计毕业</span>
          </td>
          <td>
            <span>{{getDateText(dataModel.ExpectedGraduationDate)}}</span>
          </td>
        </tr>
      </table>
    </div>
    <studiesRelatedInfoEditor ref="studiesRelatedInfoEditor" :data="dataModel" @change="onStudiesRelatedInfoEditorChange" />
  </div>
</template>

<script>
import {
  getStudyAbroadStudiesRelatedInfo,
  saveStudyAbroadStudiesRelatedInfo,
} from "@/service/studyAbroad.service";

const default_data = {
  Id: 0,
  StudentId: 0,
  EnrollmentDate: null,
  ExpectedGraduationDate: null,
  GraduationCredits: 0,
  CurrentCredits: 0,
  CurrentPerformance: 0,
};

const mixin_generalMethods = {
  methods: {
    getDateText(value) {
      let mDate = this.$moment(value);
      if (!mDate.isValid()) return String.empty;
      return mDate.format("YYYY/MM/DD");
    },
  },
};

export default {
  name: "studiesRelatedInfo",
  mixins: [mixin_generalMethods],
  components: {
    studiesRelatedInfoEditor: () => import("./studiesRelatedInfoEditor"),
  },
  props: {
    isReadonly: Boolean,
    studentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      dataModel: Object.clone(default_data),
    };
  },
  created() {
    this.loadStudyAbroadStudiesRelatedInfoFromServer();
  },
  computed: {
    studiesProgress() {
      if (!this.dataModel.GraduationCredits) return 0;
      let value = (
        (this.dataModel.CurrentCredits / this.dataModel.GraduationCredits) *
        100
      ).toFixedEx(0);
      if (value > 100) value = 100;
      return value;
    },
  },
  methods: {
    // 与服务端交互数据相关方法
    async loadStudyAbroadStudiesRelatedInfoFromServer() {
      this.isLoading = true;
      try {
        let result = await getStudyAbroadStudiesRelatedInfo(this.studentId);
        this.dataModel =
          !!result && result.success && !!result.data
            ? result.data
            : Object.clone(default_data);
        if (!this.dataModel.Id) {
          this.dataModel.StudentId = this.studentId;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async saveStudyAbroadStudiesRelatedInfoToServer(data) {
      this.isLoading = true;
      try {
        let result = await saveStudyAbroadStudiesRelatedInfo(data);
        if (!!result && result.success && result.data) {
          this.$message.success("保存校园信息成功。");

          this.loadStudyAbroadStudiesRelatedInfoFromServer();
        } else {
          this.$message.error("保存校园信息失败。");
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    onEditClick(e) {
      let { studiesRelatedInfoEditor } = this.$refs;
      if (!studiesRelatedInfoEditor) return;

      studiesRelatedInfoEditor.showDialog();
    },
    onStudiesRelatedInfoEditorChange(dataOut) {
      dataOut.StudentId = this.studentId;

      this.saveStudyAbroadStudiesRelatedInfoToServer(dataOut);
    },
  },
  watch: {
    studentId(newVal) {
      this.loadStudyAbroadStudiesRelatedInfoFromServer();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-title {
  height: 40px;
  line-height: 40px;

  .el-button {
    position: relative;
    top: -2px;
    left: 10px;
  }
}

.cs-label {
  min-width: 75px;
  width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/academicInfo/studiesRelatedInfo.vue